/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_ElectronicsInputs */

const en_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electronics`)
};

const es_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electrónica`)
};

const fr_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Électronique`)
};

const de_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektronik`)
};

const ja_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子機器`)
};

const zh_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子产品`)
};

const ar_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلكترونيات`)
};

const id_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektronik`)
};

const it_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elettronica`)
};

const ru_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электроника`)
};

const pt_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eletrônicos`)
};

const ko_listing_category_electronics = /** @type {(inputs: Listing_Category_ElectronicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전자제품`)
};

/**
* | output |
* | --- |
* | "Electronics" |
*
* @param {Listing_Category_ElectronicsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_electronics = /** @type {((inputs?: Listing_Category_ElectronicsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_ElectronicsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_electronics(inputs)
	if (locale === "es") return es_listing_category_electronics(inputs)
	if (locale === "fr") return fr_listing_category_electronics(inputs)
	if (locale === "de") return de_listing_category_electronics(inputs)
	if (locale === "ja") return ja_listing_category_electronics(inputs)
	if (locale === "zh") return zh_listing_category_electronics(inputs)
	if (locale === "ar") return ar_listing_category_electronics(inputs)
	if (locale === "id") return id_listing_category_electronics(inputs)
	if (locale === "it") return it_listing_category_electronics(inputs)
	if (locale === "ru") return ru_listing_category_electronics(inputs)
	if (locale === "pt") return pt_listing_category_electronics(inputs)
	return ko_listing_category_electronics(inputs)
});